import { View, StyleSheet } from 'react-native';
import type BulletPointModel from 'src/domain/models/BulletPointModel';
import BulletPoint from 'src/presentation/components/molecules/BulletPoint';
import Gap from 'src/presentation/components/atoms/Gap';
import Dimens from 'src/core/utils/Dimens';

type BulletPointsProps = {
	bulletPoints: BulletPointModel[];
};

const BulletPoints = ({ bulletPoints }: BulletPointsProps) => {
	return (
		<View>
			{bulletPoints.map((bulletPoint, index) => (
				<View key={index} style={styles.innerContainer}>
					<BulletPoint bulletPoint={bulletPoint} />
					{bulletPoints.length !== index + 1 && <Gap height={Dimens.gap12} />}
				</View>
			))}
		</View>
	);
};

const styles = StyleSheet.create({
	innerContainer: {
		width: '100%',
	},
});

export default BulletPoints;
